export enum LeaveApplicationStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

export const LeaveApplicationStatusLabel: Record<
  LeaveApplicationStatus,
  string
> = {
  [LeaveApplicationStatus.PENDING]: "Pending",
  [LeaveApplicationStatus.APPROVED]: "Approved",
  [LeaveApplicationStatus.REJECTED]: "Rejected",
  [LeaveApplicationStatus.CANCELLED]: "Cancelled",
};

export const LeaveApplicationStatusBadgeClass: Record<
  LeaveApplicationStatus,
  string
> = {
  [LeaveApplicationStatus.PENDING]: "bg-warning-subtle text-warning",
  [LeaveApplicationStatus.APPROVED]: "bg-success-subtle text-success",
  [LeaveApplicationStatus.REJECTED]: "bg-danger-subtle text-danger",
  [LeaveApplicationStatus.CANCELLED]: "bg-danger-subtle text-danger",
};

/** For {@link StatusBadge} (label + Bootstrap color token). */
export const leaveApplicationStatusMap: Record<
  string,
  { label: string; color: string }
> = {
  [LeaveApplicationStatus.PENDING]: {
    label: LeaveApplicationStatusLabel[LeaveApplicationStatus.PENDING],
    color: "warning",
  },
  [LeaveApplicationStatus.APPROVED]: {
    label: LeaveApplicationStatusLabel[LeaveApplicationStatus.APPROVED],
    color: "success",
  },
  [LeaveApplicationStatus.REJECTED]: {
    label: LeaveApplicationStatusLabel[LeaveApplicationStatus.REJECTED],
    color: "danger",
  },
  [LeaveApplicationStatus.CANCELLED]: {
    label: LeaveApplicationStatusLabel[LeaveApplicationStatus.CANCELLED],
    color: "danger",
  },
};
